import Paykassma from './Paykassma';
export default Paykassma;